/* eslint-disable import/no-anonymous-default-export */
import api from './api'

export default {
  // 获取所有字典
  getDict: (key?: string) => api.get('/api/common/enum/list', { params: { key } }),

  // 退出登录
  logout: (data?: { token: string }) => api.post('/account/user/logout', data)
}
